import { createAsyncThunk } from "@reduxjs/toolkit";
import apiAxios from "../../../services/apiAxios";
import {
  setError,
  setInvoiceDetails,
  setIsTrack,
  setLastOrderId,
  setLoading,
  setOrderById,
  setOrders,
  setRecordList,
  setStoreOrders,
  setStoreRecords,
  setTrackOrderData,
  updateOrder,
} from "../../Reducer/Order/OrderSlice";
import toast from "react-hot-toast";

export const fetchOrders = createAsyncThunk(
  "admin/account/Database/orders",
  async ({ page, limit, filterType }, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await apiAxios.get(
        `api/order/all?page=${page}&limit=${limit}&filter=${filterType}`
      );
      if (response?.data) {
        dispatch(setOrders(response?.data));
        dispatch(setLoading(false));
      }
    } catch (error) {
      dispatch(setError(error.toString()));
      dispatch(setLoading(false));
    }
  }
);

export const fetchOrdersOfStore = createAsyncThunk(
  "admin/fetchOrdersOfStore",
  async ({ page, limit, payload, id }, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await apiAxios.post(
        `api/store/orders/${id}?page=${page}&limit=${limit}`,
        payload
      );
      if (response?.data) {
        dispatch(setStoreOrders(response?.data));
        // dispatch( setInvoiceDetails({
        //   orderId,
        //   invoiceData: response?.data?.invoiceData,
        // }))
        dispatch(setLoading(false));
      }
    } catch (error) {
      dispatch(setError(error.toString()));
      dispatch(setLoading(false));
    }
  }
);
export const fetchRecordsOfStore = createAsyncThunk(
  "admin/fetchRecordsOfStore",
  async ({ page, limit }, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await apiAxios.get(
        `api/store/orders-active?page=${page}&limit=${limit}`
      );
      if (response?.data) {
        dispatch(setRecordList(response?.data));
        dispatch(setStoreRecords(response?.data));
        // dispatch( setInvoiceDetails({
        //   orderId,
        //   invoiceData: response?.data?.invoiceData,
        // }))
        dispatch(setLoading(false));
      }
    } catch (error) {
      dispatch(setError(error.toString()));
      dispatch(setLoading(false));
    }
  }
);
export const searchRecordsOfStore = createAsyncThunk(
  "admin/searchRecordsOfStore",
  async ({ id }, { dispatch }) => {
    // dispatch(setLoading(true));
    try {
      const response = await apiAxios.get(
        `api/store/orders-active?search=${id}`
      );
      if (response?.data) {
        dispatch(setRecordList(response?.data));
      }
    } catch (error) {
      dispatch(setError(error.toString()));
      // dispatch(setLoading(false));
    }
  }
);
export const fetchOrdersOfDoctor = createAsyncThunk(
  "admin/account/Database/orders",
  async ({ page, limit, filterType }, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await apiAxios.get(
        `api/doctor/get-orders-doctor?page=${page}&limit=${limit}&filter=${filterType}`
      );
      if (response?.data) {
        dispatch(setOrders(response?.data));
        dispatch(setLoading(false));
        dispatch(setIsTrack({}));
      }
    } catch (error) {
      dispatch(setError(error.toString()));
      dispatch(setLoading(false));
    }
  }
);

export const cancelOrder = createAsyncThunk(
  "order/cancelOrder",
  async ({ id, setOrderState }, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await apiAxios.patch(`api/order/cancel/${id}`);
      if (response?.status === 200) {
        setOrderState(id, "cancelled");
        dispatch(fetchOrders());
      } else {
        setOrderState(id, "error");
      }
      dispatch(setLoading(false));
      return response;
    } catch (error) {
      dispatch(setError(error.toString()));
      dispatch(setLoading(false));
      return error;
    }
  }
);

export const searchOrderById = createAsyncThunk(
  "admin/account/Database/orders",
  async ({ debouncedSearchTerm, currentPage, limit }, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await apiAxios.get(
        `api/auth/search-order-data?search=${debouncedSearchTerm}&page=${currentPage}&limit=${limit}`
      );
      dispatch(setOrders(response?.data));
      dispatch(setLoading(false));
      return response?.data;
    } catch (error) {
      dispatch(setError(error.toString()));
      dispatch(setLoading(false));
      return error;
    }
  }
);

export const createOrder = createAsyncThunk(
  "doctor/createOrder",
  async (order, { dispatch, rejectWithValue }) => {
    dispatch(setLoading(true));
    try {
      const response = await apiAxios.post("/api/order", order);
      toast.success("Order successfully created.");
      dispatch(setLoading(false));
      dispatch(setLastOrderId(response?.data?.message?.OID));
      dispatch(fetchOrdersOfDoctor({ page: 1, limit: 1, filterType: 'all' }));
      dispatch(setOrderById({}));
      return response;
    } catch (error) {
      console.warn(error);
      dispatch(setLoading(false));
      return error;
      // if (Object.keys(error).length > 0) {
      //   const message =
      //     error.response?.data.message || error.response?.data.error;
      //   toast.error(message);
      //   dispatch(setError(error.toString()));
      //   dispatch(setLoading(false));
      //   return rejectWithValue(
      //     error.response
      //       ? error.response?.data
      //       : { message: "Unknown error occurred" }
      //   );
      // }
    }
  }
);

export const updateOrderStatus = createAsyncThunk(
  "admin/updateOrderStatus",
  async ({ orderId, statusKey, invoiceData }, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const body = { ...statusKey, invoice: invoiceData };
      const response = await apiAxios.patch(`api/order/${orderId}`, body);
      if (response.status === 200 || response.status === 201) {
        dispatch(setLoading(false));
        let data = { orderId, statusKey };
        dispatch(updateOrder(data));
        if (response?.data?.invoiceData) {
          dispatch(
            setInvoiceDetails({
              orderId,
              invoiceData: response?.data?.invoiceData,
            })
          );
        }
      }
      return response;
    } catch (error) {
      dispatch(setError(error.toString()));
      dispatch(setLoading(false));
      return error;
    }
  }
);

export const updateOrderDetails = createAsyncThunk(
  "doctor/updateOrderDetails",
  async ({ id, order }, { dispatch, rejectWithValue }) => {
    dispatch(setLoading(true));
    try {
      const response = await apiAxios.put(`api/order/${id}`, order);
      toast.success("Order successfully Edited.");
      dispatch(setLoading(false));
      return response;
    } catch (error) {
      dispatch(setError(error.toString()));
      dispatch(setLoading(false));
      return error;
    }
  }
);

export const createPdf = createAsyncThunk(
  "doctor/createPdf",
  async (order, { dispatch, rejectWithValue }) => {
    dispatch(setLoading(true));
    try {
      const response = await apiAxios.post("/api/doctor/create-pdf", order);
      // toast.success("Pdf successfully created.");
      dispatch(setLoading(false));
      // dispatch(setLastOrderId(response?.data?.message?.OID));
      return response;
    } catch (error) {
      console.warn(error);
      dispatch(setLoading(false));
      return error;
    }
  }
);

export const createLabel = createAsyncThunk(
  "doctor/createLabel",
  async (product, { dispatch, rejectWithValue }) => {
    dispatch(setLoading(true));
    try {
      const response = await apiAxios.post(
        "/api/store/create-label-pdf",
        product
      );
      // toast.success("Label successfully created.");
      dispatch(setLoading(false));
      // dispatch(setLastOrderId(response?.data?.message?.OID));
      return response;
    } catch (error) {
      console.warn(error);
      dispatch(setLoading(false));
      return error;
    }
  }
);

export const trackOrder = createAsyncThunk(
  "trackOrder",
  async ({ orderId, phoneNumber }, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await apiAxios.post(`api/order/trackOrder`, {
        orderId,
        phoneNumber
      });
      
      // Check for successful response (200 status code)
      if (response?.status === 200 && response?.data) {
        dispatch(setTrackOrderData(response?.data));
        return response;
      } else {
        // Handle non-200 responses
        throw new Error(response?.data?.message || "Failed to track order");
      }
    } catch (error) {
      // Throw a proper error that includes the message
      const errorMessage = error?.response?.data?.message || error?.message || "Failed to track order";
      dispatch(setError(errorMessage));
      throw new Error(errorMessage);
    } finally {
      dispatch(setLoading(false));
    }
  }
);

export const updateOrderInvoice = createAsyncThunk(
  "admin/updateOrderInvoice",
  async ({ orderId, invoiceData }, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await apiAxios.patch(`api/order/update-invoice/${orderId}`, invoiceData);
      if (response.status === 200 || response.status === 201) {
        dispatch(setLoading(false));
        if (response?.data?.invoiceData) {
          dispatch(
            setInvoiceDetails({
              orderId,
              invoiceData: response?.data?.invoiceData,
            })
          );
        }
      }
      return response;
    } catch (error) {
      dispatch(setError(error.toString()));
      dispatch(setLoading(false));
      throw error;
    }
  }
);

